import useDictionary from '../dictionaries/context/useDictionary';

// Ponderado, ponderada
const WEIGHTED_WILDCARD = 'PONDERAD';

export const getWeightedRateText = (
  gT: ReturnType<typeof useDictionary>['gT'],
  popupRaw = '',
) => (popupRaw.toUpperCase().includes(WEIGHTED_WILDCARD) ? gT('weighted_rate') : '');
